<div class="main-content content-with-side-menu">
    <h1 class="page-header">
        <app-go-back></app-go-back> {{ "CampDetails.Title" | translate }}
    </h1>

    @if (model) {
        <div class="purchase-details" [formGroup]="form">
            @if (!state.isEdited(basicInfoForm)) {
                <app-camp-basic-info
                    [form]="basicInfoForm"
                ></app-camp-basic-info>
            }
            @if (state.isEdited(basicInfoForm)) {
                <app-camp-basic-info-edit
                    [form]="basicInfoForm"
                    [context]="context"
                ></app-camp-basic-info-edit>
            }
            @if (!state.isEdited(visibilityForm)) {
                <app-camp-visibility
                    [form]="visibilityForm"
                ></app-camp-visibility>
            }
            @if (state.isEdited(visibilityForm)) {
                <app-camp-visibility-edit
                    [form]="visibilityForm"
                ></app-camp-visibility-edit>
            }
            <app-camp-pricing hznTestId="camp-pricing"
                [form]="pricingDiscountsForm"
                [context]="context"
            ></app-camp-pricing>
            @if (sessionGroupForm) {
                <div>
                    <app-sessions-group
                        [form]="sessionGroupForm"
                        [context]="context"
                    ></app-sessions-group>
                </div>
            }
            <div>
                <app-camp-care [campForm]="form"></app-camp-care>
            </div>
            <app-discounts-list hznTestId="camp-discounts"
                [form]="discountsForm"
                [context]="context"
            ></app-discounts-list>
        </div>
    }
</div>
